import { useEffect, useState } from "react";
import { useUser } from "../../context/userContext";
import axios from "axios";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_icon.svg";

function ProfileModal({ initials, handleProfileClose }) {
  const { userData, setUserData } = useUser();
  const [isContentLoading, setIsContentLoading] = useState(false);

  useEffect(() => {
    handleFetchProfileData();
  }, [userData]);

  const handleFetchProfileData = async () => {
    setIsContentLoading(true);

    try {
      const response = await fetch(
        "https://soliboat.solidaridadasia.com/view-profile",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          withCredentials: true,
          body: JSON.stringify({
            email: userData.email,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setEditedFirstNameData(data.data[0].first_name);
        setEditedLastNameData(data.data[0].last_name);
        // setEditedEmailData(data.data[0].email);
      } else {
        console.error("Error fetching profile data:", response.statusText);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setIsContentLoading(false);
    }
  };

  // State variables for First Name
  const [firstNameEditMode, setFirstNameEditMode] = useState(false);
  const [editedFirstNameData, setEditedFirstNameData] = useState("");

  const handleEditFirstName = () => {
    setFirstNameEditMode(true);
  };

  const handleChangeFirstName = (value) => {
    setEditedFirstNameData(value);
  };

  const handleSaveFirstName = () => {
    setFirstNameEditMode(false);
  };

  //State variables for Last Name
  const [lastNameEditMode, setLastNameEditMode] = useState(false);
  const [editedLastNameData, setEditedLastNameData] = useState("");

  const handleEditLastName = () => {
    setLastNameEditMode(true);
  };

  const handleChangeLastName = (value) => {
    setEditedLastNameData(value);
  };

  const handleSaveLastName = () => {
    setLastNameEditMode(false);
  };

  //State variables for Email
  // const [emailEditMode, setEmailEditMode] = useState(false);
  // const [editedEmailData, setEditedEmailData] = useState("");

  // const handleEditEmail = () => {
  //   setEmailEditMode(true);
  // };

  // const handleChangeEmail = (value) => {
  //   setEditedEmailData(value);
  // };

  // const handleSaveEmail = () => {
  //   setEmailEditMode(false);
  // };

  const handleUploadProfileData = async () => {
    const editedProfileData = {
      email: userData.email,
      first_name: editedFirstNameData,
      last_name: editedLastNameData,
      mobile_number: userData.mobile_number,
    };

    try {

      setIsContentLoading(true);

      const response = await axios.post(
        "https://soliboat.solidaridadasia.com/edit-profile",
        editedProfileData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setUserData((prevUserData) => ({
          ...prevUserData,
          first_name: editedFirstNameData,
          last_name: editedLastNameData,
        }));
      }

      alert(response.data.message[0]);

      handleFetchProfileData();

      handleProfileClose();
    } catch (error) {
      console.error("Profile update failed:", error.message);
    } finally {
      setIsContentLoading(false);
    }
  };

  return (
    <>
      {/* Loading screen while API calls are in progress */}
      {isContentLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-50 z-[100]">
          <div className="w-20 h-20 animate-spin">
            <div className="h-full w-full border-4 border-t-dark/50 border-b-dark/80 rounded-[50%]" />
          </div>
          <div className="text-center text-sm lg:text-xl font-medium text-gray-500 mt-8 mx-8 lg:mx-0">
            Please wait while while we process your request{" "}
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
          </div>
        </div>
      )}

      <div className="fixed inset-0 flex items-center justify-center drop-shadow-[0_4px_24px_rgba(0,0,0,0.24)] z-50">
        <div className="fixed inset-0 bg-black opacity-50" />

        <div className="relative w-[90%] lg:w-3/4 xl:w-1/2 bg-white p-[2px] rounded-xl">
          <div className="flex flex-col justify-center items-center w-full mb-6 bg-gradient-to-b from-blue-400/30 rounded-t-xl">
            <div
              className="absolute top-3 right-3 flex rounded-full cursor-pointer hover:scale-[105%]"
              onClick={handleProfileClose}
            >
              <CloseIcon className="w-8 h-8" />
            </div>

            <span className="flex items-center justify-center w-20 h-20 mt-8 text-black text-3xl border-4 border-white/80    rounded-full bg-neutral-100">
              {initials}
            </span>
            <p className="mt-4 text-gray-900 text-2xl font-semibold">
              View Profile
            </p>
            <p className="mt-1 mx-2 text-center text-sm md:text-base text-gray-400 font-medium">
              Update your profile to reflect the best version of yourself!
            </p>
          </div>

          <div className="mt-3 border border-neutral-100" />

          <div className="mt-4 mb-4 md:mb-6 mx-4 md:mx-7">
            <h1 className="mb-3 text-lg font-semibold text-gray-900">
              Profile Details:
            </h1>

            {/* Name */}
            <div className="flex justify-between mb-4">
              {/* First Name */}
              <div className="w-[48%]">
                <div className="flex justify-between">
                  <label
                    htmlFor="name"
                    className="mb-1 block font-medium text-slate-500 dark:text-white"
                  >
                    {" "}
                    First Name{" "}
                  </label>
                  {firstNameEditMode ? (
                    <button
                      className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                      onClick={() => handleSaveFirstName()}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                      onClick={() => handleEditFirstName()}
                    >
                      Edit
                    </button>
                  )}
                </div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter your first name"
                  value={editedFirstNameData}
                  onChange={(e) => handleChangeFirstName(e.target.value)}
                  className="w-full rounded-md py-2 px-2 md:px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                  disabled={!firstNameEditMode}
                />
              </div>
              {/* End of First Name */}

              {/* Last Name */}
              <div className="w-[48%]">
                <div className="flex justify-between">
                  <label
                    htmlFor="last_name"
                    className="mb-1 block font-medium text-slate-500 dark:text-white"
                  >
                    Last Name
                  </label>
                  {lastNameEditMode ? (
                    <button
                      className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                      onClick={() => handleSaveLastName()}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                      onClick={() => handleEditLastName()}
                    >
                      Edit
                    </button>
                  )}
                </div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter your last name"
                  value={editedLastNameData}
                  onChange={(e) => handleChangeLastName(e.target.value)}
                  className="w-full rounded-md py-2 px-2 md:px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                  disabled={!lastNameEditMode}
                />
              </div>
              {/* End of Last Name */}
            </div>
            {/* End of Name */}

            {/* Email */}
            <div className="mb-4">
              <div className="flex justify-between">
                <label
                  htmlFor="email"
                  className="mb-1 block font-medium text-slate-500 dark:text-white"
                >
                  Email
                </label>
                {/*{emailEditMode ? (
                  <button
                    className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                    onClick={() => handleSaveEmail()}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    className="text-base font-semibold text-dark hover:opacity-80 hover:underline dark:text-white"
                    onClick={() => handleEditEmail()}
                  >
                    Edit
                  </button>
                )}*/}
              </div>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={userData.email}
                //onChange={(e) => handleChangeEmail(e.target.value)}
                className="w-full rounded-md py-2 px-2 md:px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                disabled //={!emailEditMode}
              />
            </div>
            {/* End of Email */}

            {/* Telephone (tel) */}
            <div className="mb-4">
              <div className="flex justify-between">
                <label
                  htmlFor="tel"
                  className="mb-1 block font-medium text-slate-500 dark:text-white"
                >
                  Telephone (tel)
                </label>
              </div>
              <input
                type="tel"
                name="tel"
                value={userData.mobile_number}
                className="w-full rounded-md py-2 px-2 md:px-4 text-base text-body-color placeholder-body-color outline-none border-2 border-gray-300 focus:border-primary focus-visible:shadow-none disabled:bg-gray-100 disabled:cursor-not-allowed dark:bg-[#242B51] dark:shadow-signUp"
                disabled
              />
            </div>
            {/* End of Telephone (tel) */}

            <div className="flex justify-end items-center pt-2">
              <button
                className="bg-primary text-white px-2 py-2 rounded-md"
                onClick={handleUploadProfileData}
              >
                Update Details
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileModal;
